import { net_filemanage } from "@/api/http";
export const API_STFMFM02C22 = (...params) =>
net_filemanage.post("/api/STFMFM02C22/GetFolderInfoList", ...params)